import ProcessHeaderEditor from './process/components/ProcessHeaderEditor';
import ProcessHeaderView from './process/components/ProcessHeaderView';

import ProdHeaderView from './order/components/ProdHeaderView';
import ProdHeaderEditor from './order/components/ProdHeaderEditor';
import ProdOrderProcessEditor from './order/components/ProdOrderProcessEditor';
import ProdShorthand from './order/components/ProdShorthand';
import ProdTaskList from './order/components/ProdTaskList';
import ProdTaskBom from './order/components/ProdTaskBom';
import ProdPlanGridControl from './plan/components/ProdPlanGridControl';
import ProdPlanGridItem from './plan/components/ProdPlanGridItem';

import ProdIOOSumView from './order/components/ProdIOOSumView';
import ProdIOOExiView from './order/components/ProdIOOExiView';
import ProdIOOReqView from './order/components/ProdIOOReqView';

import ProdIOOExoView from './order/components/ProdIOOExoView';
import ProdIOOExoSumView from './order/components/ProdIOOExoSumView';

import ProdIOOExiBom from './order/components/ProdIOOExiBom';
import ProdIOOReqAdd from './order/components/ProdIOOReqAdd';
import ProdIOOExiMaterialEditor from './order/components/ProdIOOExiMaterialEditor';
import ProdIOOExiMetalEditor from './order/components/ProdIOOExiMetalEditor';
import ProdIOOExiStoneEditor from './order/components/ProdIOOExiStoneEditor';
import ProdIOOExoMaterialEditor from './order/components/ProdIOOExoMaterialEditor';
import ProdIOOExoMetalEditor from './order/components/ProdIOOExoMetalEditor';
import ProdIOOExoStoneEditor from './order/components/ProdIOOExoStoneEditor';

import ProdTaskDetail from "./order/components/ProdTaskDetail"
import ProdTaskHeader from "./order/components/ProdTaskHeader";
import ProdTaskActionHeader from "./order/components/ProdTaskActionHeader"

import ProdTaskIssue from "./order/components/ProdTaskIssue"
import ProdIOTIssMat from "./order/components/ProdIOTIssMat"
import ProdIOTSumMat from "./order/components/ProdIOTSumMat"
import ProdIOTSumOP from "./order/components/ProdIOTSumOP"
import ProdTaskReturn from "./order/components/ProdTaskReturn"
import ProdIOTRetMat from "./order/components/ProdIOTRetMat"
import ProdAction from "./order/components/ProdAction"

import ProdTaskWastage from "./order/components/ProdTaskWastage"
import ProdTaskWastageRow from "./order/components/ProdTaskWastageRow"
import ProdWastage from "./order/components/ProdWastage"

import ProdMatrixContainer from "./order/components/ProdMatrixContainer"
import ProdMatrix from "./order/components/ProdMatrix"
import ProdMatrixRow from "./order/components/ProdMatrixRow"
import ProdMatrixHeader from "./order/components/ProdMatrixHeader"

import ProdIOTRetOP from "./order/components/ProdIOTRetOP"
import ProdIOTRetOPRow from "./order/components/ProdIOTRetOPRow"
import ProdIOTRetMetalEditor from "./order/components/ProdIOTRetMetalEditor"
import ProdIOTRetStoneEditor from "./order/components/ProdIOTRetStoneEditor"

import ProdIOOOutView from "./order/components/ProdIOOOutView" 
import ProdIOOOutViewRow from "./order/components/ProdIOOOutViewRow"
import ProdIOOOutExo from "./order/components/ProdIOOOutExo"
import ProdIOOQceExo from "./order/components/ProdIOOQceExo"

import ProdIOORetView from "./order/components/ProdIOORetView"
import ProdIOORetViewRow from "./order/components/ProdIOORetAddRow"
import ProdIOOOfrView from "./order/components/ProdIOOOfrView"
import ProdIOOOfrViewRow from "./order/components/ProdIOOOfrViewRow"
import ProdIOOOmrView from "./order/components/ProdIOOOmrView"
import ProdIOOOmrViewRow from "./order/components/ProdIOOOmrViewRow"

import ProdIOOOfrAdd from "./order/components/ProdIOOOfrAdd"
import ProdIOOOfrAddRow from "./order/components/ProdIOOOfrAddRow"
import ProdIOOOmrAdd from "./order/components/ProdIOOOmrAdd"
import ProdIOOOmrAddRow from "./order/components/ProdIOOOmrAddRow"

import itemViewMap from '../../item/Index';
import cmnViewMap from '../../cmn/Index';
import systemViewMap from '../../system/Index';
import projectViewmap from "../Index";

import ItemShorthand from '../../item/item/components/ItemShorthand';
import ProfileShorthand from "../../profile/components/ProfileShorthand";
import CategoryMasterSH from '../../system/category/components/CategoryMasterSH';
import CategoryDetailSH from '../../system/category/components/CategoryDetailSH';

import ProjectTimesheet from "../components/ProjectTimesheet"
import ProjectTimesheetRow from "../components/ProjectTimesheetRow"
import ProjectHoldResumeEditor from "../components/ProjectHoldResumeEditor"
import ProjectHoldHistory from "../components/ProjectHoldHistory"

import DirectPrint from '../../system/printers/DirectPrint';
import ProdIOORetAdd from './order/components/ProdIOORetAdd';
import ProdIOORetAddRow from './order/components/ProdIOORetAddRow';
import ProdIOORecView from './order/components/ProdIOORecView';
import ProdJOTaskDashRow from './order/components/ProdJOTaskDashRow';
import ProdJOTaskMini from './order/components/ProdJOTaskMini';
import ProdDeductionTaskSH from './order/components/ProdDeductionTaskSH';

const prodViewMap = {
    "vProcessHeaderViewer":ProcessHeaderView,
    "vProcessHeaderEditor":ProcessHeaderEditor,
    "vProdHeaderViewer":ProdHeaderView,
    "vProdHeaderEditor":ProdHeaderEditor,
    "vProdSH":ProdShorthand,
    
    "vProdTaskList":ProdTaskList,
    "vProdTaskBom":ProdTaskBom,
    "vProdPlanGridControl": ProdPlanGridControl,
    "vProdPlanGridItem": ProdPlanGridItem,
    "vProdIOOSumView":ProdIOOSumView,
    "vProdIOOExiView":ProdIOOExiView,
    "vProdIOOReqView":ProdIOOReqView,

    "vProdIOORecView":ProdIOORecView,

    "vProdIOOExiBom":ProdIOOExiBom,
    "vProdIOOReqAdd":ProdIOOReqAdd,
    "vProdIOExiEditor_1": ProdIOOExiMaterialEditor,
    "vProdIOExiEditor_1001": ProdIOOExiMetalEditor,
    "vProdIOExiEditor_1002": ProdIOOExiStoneEditor,

    "vProdIOOExoView":ProdIOOExoView,
    "vProdIOOExoSumView":ProdIOOExoSumView,

    "vProdIOOExoBom":ProdIOOExiBom,
    "vProdIOExoEditor_1": ProdIOOExoMaterialEditor,
    "vProdIOExoEditor_1001": ProdIOOExoMetalEditor,
    "vProdIOExoEditor_1002": ProdIOOExoStoneEditor,
    
    "vOrderProcessEditor":ProdOrderProcessEditor,
    "vProdTaskDetail":ProdTaskDetail,
    "vProdTaskHeaderViewer":ProdTaskHeader,
    "vProdTaskIssue":ProdTaskIssue,
    "vProdTaskIssHeaderViewer":ProdTaskActionHeader,
    "vProdTaskRetHeaderViewer":ProdTaskActionHeader,
    "vProdIOTIssMat":ProdIOTIssMat,
    "vProdIOTSumMat":ProdIOTSumMat,
    "vProdIOTSumOP":ProdIOTSumOP,
    "vProdTaskReturn":ProdTaskReturn,
    "vProdIOTRetMat":ProdIOTRetMat,
    "vProdActionViewer":ProdAction,

    "vJOTaskDashRow":ProdJOTaskDashRow,
    "vJOTaskMini":ProdJOTaskMini,

    "vProdTaskWastage":ProdTaskWastage,
    "vProdTaskWastageEditor":ProdTaskWastageRow,
    "vProdWastage":ProdWastage,

    "vProdDeductionTaskSH":ProdDeductionTaskSH,

    "vProdMatrix":ProdMatrix,
    "vProdMatrixEditor":ProdMatrixRow,
    "vProdMatrixRow":ProdMatrixRow,
    "vProdMatrixHeader":ProdMatrixHeader,

    "vProdMatrixContainer":ProdMatrixContainer,
    "vProdIOTRetOP":ProdIOTRetOP,
    "vProdIOTRetOPRow":ProdIOTRetOPRow,
    "vProdIOTRetOPEditor_1001": ProdIOTRetMetalEditor,
    "vProdIOTRetOPEditor_1002": ProdIOTRetStoneEditor,

    "vProdIOOOutView":ProdIOOOutView, 
    "vProdIOOOutViewRow":ProdIOOOutViewRow,
    "vProdIOOOutExo":ProdIOOOutExo,
    "vProdIOOQceExo":ProdIOOQceExo,

    "vProdIOORetAdd":ProdIOORetAdd,
    "vProdIOORetAddRow":ProdIOORetAddRow,

    "vProdIOORetView":ProdIOORetView,
    "vProdIOORetViewRow":ProdIOORetViewRow,

    "vProdIOOOfrView":ProdIOOOfrView,
    "vProdIOOOfrViewRow":ProdIOOOfrViewRow,
    "vProdIOOOmrView":ProdIOOOmrView,
    "vProdIOOOmrViewRow":ProdIOOOmrViewRow,

    "vProdIOOOfrAdd":ProdIOOOfrAdd,
    "vProdIOOOfrAddRow":ProdIOOOfrAddRow,
    "vProdIOOOmrAdd":ProdIOOOmrAdd,
    "vProdIOOOmrAddRow":ProdIOOOmrAddRow,

    "vCatMasterSH": CategoryMasterSH,
    "vCatDetailSH": CategoryDetailSH,
    "vProShorthand": ProfileShorthand,
    "vItemShorthand": ItemShorthand,

    "vDirectPrint": DirectPrint,

    "vProjectTS":ProjectTimesheet,
    "vProjectTSRow":ProjectTimesheetRow,
    "vProjectHoldResumeEditor":ProjectHoldResumeEditor,
    "vProjectHoldHistory":ProjectHoldHistory,

    ...itemViewMap,
    ...cmnViewMap,
    ...systemViewMap,
    ...projectViewmap
}

export default prodViewMap;
